import { createStore } from 'vuex';
import teamInfo, {
  initialTeamInfoState,
  TeamInfoState,
} from '@/stores/common-modules/teamInfo';
import teamUsers, {
  initialTeamUsersState,
  TeamUsersState,
} from '@/stores/common-modules/teamUsers';
import articleShare, {
  ArticleShareState,
  initialArticleShareState,
} from '@/stores/pc-modules/articleShare';
import confirmationModal, {
  ConfirmationModalState,
  initialConfirmationModalState,
} from '@/stores/pc-modules/confirmationModal';
import downloadActionData, {
  DownloadActionDataState,
  initialDownloadActionDataState,
} from '@/stores/pc-modules/downloadActionData';
import feedType, {
  FeedTypeState,
  initialFeedTypeState,
} from '@/stores/pc-modules/feedType';
import groups, {
  GroupsState,
  initialGroupsState,
} from '@/stores/pc-modules/groups';
import route, {
  initialRouteState,
  RouteState,
} from '@/stores/pc-modules/route';
import searchResults, {
  initialSearchResultsState,
  SearchResultsState,
} from '@/stores/pc-modules/searchResults';
import themeList, {
  initialThemeListState,
  ThemeListState,
} from '@/stores/pc-modules/themeList';
import userEditModal, {
  initialUserEditModalState,
  UserEditModalState,
} from '@/stores/pc-modules/userEditModal';
import userInfo, {
  initialUserInfoState,
  UserInfoState,
} from '@/stores/pc-modules/userInfo';
import header, { HeaderState, initialHeaderState } from './pc-modules/header';
import mailAddress, {
  initialMailAddressState,
  MailAddressState,
} from './pc-modules/mailAddress';
import notification, {
  initialNotificationState,
  NotificationState,
} from './pc-modules/notification';
import notificationPopup, {
  initialNotificationPopupState,
  NotificationPopupState,
} from './pc-modules/notificationPopup';
import survey, { initialSurveyState, SurveyState } from './pc-modules/survey';
import userDocumentNotification, {
  initialUserDocumentNotificationState,
  UserDocumentNotificationState,
} from './pc-modules/userDocumentNotification';
import webPush, {
  initialWebPushSubScriptionState,
  WebPushSubscriptionState,
} from './pc-modules/webPush';

export type RootState = {
  themeList: ThemeListState;
  userInfo: UserInfoState;
  header: HeaderState;
  confirmationModal: ConfirmationModalState;
  userEditModal: UserEditModalState;
  teamUsers: TeamUsersState;
  teamInfo: TeamInfoState;
  searchResults: SearchResultsState;
  articleShare: ArticleShareState;
  groups: GroupsState;
  feedType: FeedTypeState;
  route: RouteState;
  downloadActionData: DownloadActionDataState;
  mailAddress: MailAddressState;
  notificationPopup: NotificationPopupState;
  notification: NotificationState;
  userDocumentNotification: UserDocumentNotificationState;
  webPush: WebPushSubscriptionState;
  survey: SurveyState;
};

const initialState: RootState = {
  themeList: Object.assign({}, initialThemeListState),
  userInfo: Object.assign({}, initialUserInfoState),
  header: Object.assign({}, initialHeaderState),
  confirmationModal: Object.assign({}, initialConfirmationModalState),
  userEditModal: Object.assign({}, initialUserEditModalState),
  teamUsers: Object.assign({}, initialTeamUsersState),
  teamInfo: Object.assign({}, initialTeamInfoState),
  searchResults: Object.assign({}, initialSearchResultsState),
  articleShare: Object.assign({}, initialArticleShareState),
  groups: Object.assign({}, initialGroupsState),
  feedType: Object.assign({}, initialFeedTypeState),
  route: Object.assign({}, initialRouteState),
  downloadActionData: Object.assign({}, initialDownloadActionDataState),
  mailAddress: Object.assign({}, initialMailAddressState),
  notificationPopup: Object.assign({}, initialNotificationPopupState),
  notification: Object.assign({}, initialNotificationState),
  userDocumentNotification: Object.assign(
    {},
    initialUserDocumentNotificationState,
  ),
  webPush: Object.assign({}, initialWebPushSubScriptionState),
  survey: Object.assign({}, initialSurveyState),
};

export default createStore({
  modules: {
    themeList,
    userInfo,
    header,
    confirmationModal,
    userEditModal,
    teamUsers,
    teamInfo,
    searchResults,
    articleShare,
    groups,
    feedType,
    route,
    downloadActionData,
    mailAddress,
    notificationPopup,
    notification,
    userDocumentNotification,
    webPush,
    survey,
  },
  mutations: {
    resetState(moduleList: RootState) {
      Object.keys(moduleList).forEach(key => {
        Object.assign(
          moduleList[key as keyof RootState],
          initialState[key as keyof RootState],
        );
      });
    },
  },
});
